import { useMemo } from "react";
import { SearchNormal, UserAdd } from "iconsax-reactjs";
import { Button, Input, Select } from "../../../../shared/ui";

type Option = {
  value: string;
  label: string;
};

type MembersFiltersBarProps = {
  query: string;
  onQueryChange: (value: string) => void;
  sort: string;
  onSortChange: (value: string) => void;
  sortOptions: Option[];
  roleTypes: string[];
  onRoleTypesChange: (values: string[]) => void;
  roleTypeOptions: Option[];
  onInviteClick: () => void;
};

const MembersFiltersBar = ({
  query,
  onQueryChange,
  sort,
  onSortChange,
  sortOptions,
  roleTypes,
  onRoleTypesChange,
  roleTypeOptions,
  onInviteClick,
}: MembersFiltersBarProps) => {
  const selectedRoleValue = useMemo(() => {
    if (roleTypes.includes("all") || roleTypes.length === 0) return "all";
    return roleTypes[0];
  }, [roleTypes]);

  return (
    <div className="my-4 flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between">
      <Button
        type="button"
        onClick={onInviteClick}
        className="order-1 h-11 w-1/2 self-start px-5 text-[14px] font-[550] sm:w-fit lg:order-2"
      >
        <UserAdd size={18} />
        Invite members
      </Button>

      <div className="order-2 flex flex-1 flex-col gap-3 lg:order-1 lg:flex-row lg:items-center">
        <Input
          value={query}
          onChange={(event) => onQueryChange(event.target.value)}
          placeholder="Search members"
          startIcon={<SearchNormal size={20} className="text-[#6F739B]" />}
          className="w-full lg:w-[360px]"
        />

        <div className="hidden h-10 w-px bg-[#EEF1FB] lg:block" />

        <div className="flex w-full  gap-3 lg:flex lg:w-auto lg:flex-wrap lg:items-center">
          <Select
            value={sort}
            onChange={onSortChange}
            title="Sort by"
            placeholder="Recently added"
            triggerPrefix="Sort"
            className="w-full self-start lg:w-auto"
            options={sortOptions}
          />
          <Select
            value={selectedRoleValue}
            onChange={(value) => onRoleTypesChange([value])}
            title="Role"
            placeholder="All"
            triggerPrefix="Role"
            className="w-full self-start lg:w-auto"
            options={roleTypeOptions}
          />
        </div>
      </div>
    </div>
  );
};

export default MembersFiltersBar;
